import { Modal, ModalBlock } from '@sb1/ffe-modals-react';
import { Heading2 } from '@sb1/ffe-core-react';
import RoundedButtonPrimary from '../../../components/button/rounded-button-primary/RoundedButtonPrimary';
import styles from './give-support.module.less';

export const GiverprisModal = ({ modalRef }) => {
    return (
        <Modal ref={modalRef} ariaLabelledby={'giverpris-modal-header'}>
            <ModalBlock>
                <Heading2 id={'giverpris-modal-header'}>Hvorfor giverpris?</Heading2>
                <p>
                    Giverprisen på 2 kroner per donasjon går direkte til å dekke kostnader knyttet til drift,
                    vedlikehold og videreutvikling av Spleis. Dette inkluderer å ha de rette folkene på plass –
                    mennesker som hver dag jobber for at det skal være trygt og sikkert å samle inn penger, at
                    innsamlingene følger våre vilkår, og at flest mulig får muligheten til å realisere sine ideer,
                    prosjekter og initiativ.
                </p>
                <p>
                    Verken Spleis eller SpareBank 1 tjener penger på tjenesten. Inntektene våre dekker langt fra de
                    faktiske kostnadene, og vi går med millioner i underskudd hvert eneste år. Dette underskuddet dekkes
                    i dag av SpareBank 1-bankene, som investerer i Spleis fordi de ser det som en viktig del av sitt
                    samfunnsansvar.
                </p>
                <p>
                    Målet vårt er å oppnå en bedre balanse mellom inntekter og utgifter, slik at Spleis kan bestå – og
                    slik at folk fortsatt kan bruke tjenesten til å oppnå drømmene sine.
                </p>

                <RoundedButtonPrimary className={styles.modalButton} onClick={() => modalRef?.current?.close()}>
                    Lukk
                </RoundedButtonPrimary>
            </ModalBlock>
        </Modal>
    );
};
